(function () {
    function backgroundLazy() {
        const $targets = document.querySelectorAll('[data-bg-lazy]');
        let switchBg = screen.width > 768 ? 'data-desktop' : 'data-mobile';
        $targets.forEach(($target) => {
            const uri = $target.getAttribute(switchBg);
            $target.style.setProperty("background-image", `url(${uri})`);
        });
    }
    myonce('bgLazy', function () {
        backgroundLazy();
    });
    window.addEventListener("orientationchange", () => {
        backgroundLazy();
    });
}());
